'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

BEGIN.pageScript = BEGIN.pageScript || {
  init: {}
};

BEGIN.pageScript = function () {
  // コンストラクタ  =================================================================
  function init() {
    initSlider();
    $('#js-prArticle')[0] && initPrArticle();
    $('[data-modal-key]')[0] && initModal();
    $('.js-cvContainer')[0] && initCVButton();
  }

  /*
  *スライダー生成
  *　
  */
  function initSlider() {
    $('p,div').each(function () {
      var $imgTags = $(this).children("img");
      if ($imgTags.length < 3) return;

      var el = new Slider($(this));
      el.init();
    });
  }

  var Slider = function () {
    function Slider(target) {
      _classCallCheck(this, Slider);

      this.target = target;
      this.imgs = this.target.children('img');
      this.imgSrcArr = [];
      this.sliderHtml = '';
      this.thumbsHtml = '';
      this.sliderLength = 0;
      this.thumbsLength = 0;
      this.sliderVar;
      this.thumbsVar;
      this.thumbNodeSize = [];
    }

    _createClass(Slider, [{
      key: 'init',
      value: function init() {
        var _this2 = this;

        this.getImgSrc().then(function () {
          _this2.setSliderHtml();
          _this2.setThumbsHtml();
          _this2.setWrapperHtml();
        }).then(function () {
          _this2.setSlider();
          _this2.setThumbsSlider();
          _this2.sliderLink();
          _this2.setTotalCount();
        });
      }
    }, {
      key: 'getImgSrc',
      value: function getImgSrc() {
        var _this3 = this;

        // imgタグの情報取得
        return new Promise(function (resolve, reject) {
          var _this = _this3;
          _this3.imgs.each(function () {
            var src = $(this).attr('src');
            var alt = $(this).attr('alt');

            _this.imgSrcArr.push({
              'src': src,
              'alt': alt
            });
          });
          // console.log('getImgSrc done');
          resolve();
        });
      }
    }, {
      key: 'setSliderHtml',
      value: function setSliderHtml() {
        var _this4 = this;

        // スライダーのHTML生成
        return new Promise(function (resolve, reject) {
          var _this = _this4;

          _this4.sliderHtml = '<div class="slider js-slider">\n                      <div class="sliderCount"></div>\n                      <div class="sliderInner swiper-wrapper">\n                        ' + _this.setSliderNodeHtml() + '\n                      </div>\n                      <div class="sliderArrow sliderArrow-prev"></div>\n                      <div class="sliderArrow sliderArrow-next"></div>\n                    </div>';

          // console.log('setSliderHtml done');
          resolve();
        });
      }
    }, {
      key: 'setSliderNodeHtml',
      value: function setSliderNodeHtml() {
        // スライダーの子要素HTML生成
        var _this = this;
        var sliderNodeHtml = '';
        $.each(_this.imgSrcArr, function (index, value) {
          var src = value['src'];
          var alt = value['alt'];
          var captionHtml = '';
          console.log('alt : ' + alt);
          if (alt != '' && alt != undefined) {
            captionHtml = '<figcaption>' + alt + '</figcaption>';
          }
          sliderNodeHtml += '<div class="sliderNode swiper-slide">\n            <figure class="sliderimg">\n              <img src="' + src + '" alt="' + alt + '" />\n            </figure>\n            ' + captionHtml + '\n          </div>';
        });

        return sliderNodeHtml;
      }
    }, {
      key: 'setThumbsHtml',
      value: function setThumbsHtml() {
        var _this5 = this;

        // サムネイルのHtml生成
        return new Promise(function (resolve, reject) {
          var _this = _this5;
          _this5.thumbsHtml = '<div class="thumbsWrap js-thumbsWrap">\n                      <div class="thumbsSlider js-thumbsSlider">\n                        <div class="thumbsInner swiper-wrapper">\n                          ' + _this.setThumbsNodeHtml() + '\n                        </div>\n                      </div>\n                    </div>';

          // console.log('setThumbsHtml done');
          resolve();
        });
      }
    }, {
      key: 'setThumbsNodeHtml',
      value: function setThumbsNodeHtml() {
        // サムネイルの子要素Html生成
        var _this = this;
        var thumbsNodeHtml = '';
        $.each(_this.imgSrcArr, function (index, value) {
          var src = value['src'];
          var alt = value['alt'];
          thumbsNodeHtml += '<div class="thumbsNode swiper-slide">\n            <div class="thumbsNode_img">\n              <img src="' + src + '" alt="' + alt + '" />\n            </div>\n          </div>';
        });

        return thumbsNodeHtml;
      }
    }, {
      key: 'setWrapperHtml',
      value: function setWrapperHtml() {
        var _this6 = this;

        // ラッパーで囲む
        return new Promise(function (resolve, reject) {
          var _this = _this6;
          var wrapperHtml = '<div class="sliderWrapper">\n                          ' + _this6.sliderHtml + '\n                          ' + _this6.thumbsHtml + '\n                        </div>';

          _this6.target.html(wrapperHtml);
          resolve();
        });
      }
    }, {
      key: 'setSlider',
      value: function setSlider() {
        // スライダーセット
        var _this = this;
        var slider = _this.target.find('.js-slider');
        var $pager = slider.find('.sliderCount');
        this.sliderLength = slider.find('.sliderNode').length;

        this.sliderVar = new Swiper(slider[0], {
          loop: true,
          loopAdditionalSlides: 1,
          loopedSlides: _this.sliderLength,
          navigation: {
            nextEl: slider.find('.sliderArrow-next')[0],
            prevEl: slider.find('.sliderArrow-prev')[0]
          },
          pagination: {
            el: $pager[0],
            type: "custom",
            renderCustom: function renderCustom(swiper, current, total) {
              return current + '/' + total;
            }
          }
        });
      }
    }, {
      key: 'setThumbsSlider',
      value: function setThumbsSlider() {
        // サムネイルスライダーセット
        var _this = this;
        var slider = _this.target.find('.js-thumbsSlider');
        this.thumbsLength = slider.find('.thumbsNode').length;
        this.thumbNodeSize = {
          'w': slider.find('.thumbsNode').eq(0).outerWidth(true),
          'h': slider.find('.thumbsNode').eq(0).outerHeight(true)
        };
        this.thumbsVar = new Swiper(slider[0], {
          loop: true,
          loopedSlides: _this.thumbsLength,
          loopAdditionalSlides: 100,
          direction: 'horizontal',
          allowTouchMove: false,
          slideToClickedSlide: true,
          spaceBetween: 5,
          breakpoints: {
            768: {
              direction: 'vertical',
              spaceBetween: 0
            }
          }
        });

        this.getThumbsWrapSize();
      }
    }, {
      key: 'getThumbsWrapSize',
      value: function getThumbsWrapSize() {
        // サムネイルの表示範囲
        if (BEGIN.data.$MQ == 'SP') return;
        var _this = this;
        var thumbsWrap = _this.target.find('.js-thumbsWrap');

        // console.log(this.thumbNodeSize);

        if (this.thumbsLength < 5) {
          thumbsWrap.height(_this.thumbNodeSize['h'] * (this.thumbsLength * 1.5));
        }
      }
    }, {
      key: 'sliderLink',
      value: function sliderLink() {
        // スライダーを連動
        this.sliderVar.controller.control = this.thumbsVar;
        this.thumbsVar.controller.control = this.sliderVar;
      }
    }, {
      key: 'setTotalCount',
      value: function setTotalCount() {
        // カウント初期化
        this.target.find('.js-totalNum').text(this.sliderLength);
      }
    }]);

    return Slider;
  }();

  /**
  * モーダル設定
  */


  var initModal = function initModal() {
    var modal = document.querySelector('.js-modal');
    var closeTriggers = document.querySelectorAll('.js-modalClose');
    var openTriggers = document.querySelectorAll('.js-modalOpen');

    closeTriggers.forEach(function (closeTrigger) {
      closeTrigger.addEventListener('click', function () {
        var activeContent = document.querySelector('.js-modalContent.is-active');
        activeContent.classList.remove('is-active');

        modal.classList.remove('is-active');
      });
    });

    openTriggers.forEach(function (openTrigger) {
      openTrigger.addEventListener('click', function (e) {
        var target = e.target;


        var modalKey = target.closest('[data-modal-key]').dataset.modalKey;

        var activateContent = document.querySelector('.js-modalContent[data-modal-key="' + modalKey + '"]');

        activateContent.classList.add('is-active');
        modal.classList.add('is-active');
      });
    });
  };

  /**
  * コンバージョンボタン設定
  */
  var initCVButton = function initCVButton() {
    var container = document.querySelector('.js-cvContainer');
    var button = document.querySelector('.js-cvButton');

    window.addEventListener('scroll', function () {
      if (10 <= window.scrollY) {
        button.classList.add('is-animated');
      } else {
        button.classList.remove('is-animated');
      }
    });
  };

  /*
  * 2件目表示記事
  *　
  */
  function initPrArticle() {
    var article = new PrArticle();
    article.init();
  }

  var PrArticle = function () {
    function PrArticle() {
      _classCallCheck(this, PrArticle);

      this.target = $('#js-prArticle');
      this.currentContent = $('.js-articlesSingleInner');
      this.targetNode = this.target.find('.js-prArticleNode');
      this.randomIndex = Math.floor(Math.random() * this.targetNode.length);
      this.url = this.targetNode.eq(this.randomIndex).val();
      this.nextContent = '';
      this.targetOffsetTop = this.target.offset().top;
      this.appendFlg = true;
    }

    _createClass(PrArticle, [{
      key: 'init',
      value: function init() {
        var _this = this;
        BEGIN.data.$window.on('scroll', function () {
          _this.scrollEvent();
        });
      }
    }, {
      key: 'scrollEvent',
      value: function scrollEvent() {
        var _this = this;

        if (_this.appendFlg && BEGIN.data.scrollTop + BEGIN.data.winH >= _this.targetOffsetTop) {
          _this.contentLoad().done(function (data, textStatus, jqXHR) {
            _this.nextContent = $(data).find('.js-articlesSingleInner').addClass('is-pr');
            var nextTitle = $(data).find('.articlesSingle_title').text();

            _this.currentContent.after(_this.nextContent);

            dataLayer = dataLayer || [];
            dataLayer.push({
              'v_page_location': this.url,
              'V_page_title': nextTitle,
              'event': 'v_page_view'
            });

            // 読み込み記事のために再度スライダー初期化
            initSlider();
          });
          _this.appendFlg = false;
        }
      }
    }, {
      key: 'contentLoad',
      value: function contentLoad() {
        var _this = this;
        var defer = $.Deferred();
        var response = $.ajax({
          type: 'GET',
          url: _this.url,
          datatype: 'html'
        }).done(function (data) {
          defer.resolve();
          console.log('pr resolve');
        }).fail(function (data) {
          console.log('pr fail');
        });

        return defer.promise(), response;
      }
    }]);

    return PrArticle;
  }();

  return {
    init: init
  };
}();

BEGIN.common.init(BEGIN.pageScript.init);